export enum EventType {
  Visited = 'visited',
  Updated = 'updated',
  Created = 'created',
  CheckoutOpened = 'checkout-opened',
  PaymentPrepared = 'payment-prepared',
}
